import React from "react";
import "../css/Services.css";

const Services = () => {
  return (
    <div className="services7">

      {/* ================= HERO ================= */}
      <section className="srv7-hero">
        <h1>Our Services</h1>
        <p>Everything you need to train smarter, stronger, and longer.</p>
      </section>


      {/* ================= CORE SERVICES ================= */}
      <section className="srv7-core">
        <h2>Core Training Services</h2>

        <div className="core-grid">
          <div className="core-card">
            <h3>Personal Training</h3>
            <p>
              One-on-one coaching with structured programming,
              accountability, and progressive performance tracking.
            </p>
          </div>

          <div className="core-card">
            <h3>Group Training</h3>
            <p>
              Small-group sessions combining strength, conditioning,
              and competitive energy in a controlled format.
            </p>
          </div>

          <div className="core-card">
            <h3>Strength Programs</h3>
            <p>
              Periodized lifting systems focused on compound movements,
              joint health, and long-term progression.
            </p>
          </div>

          <div className="core-card">
            <h3>Conditioning Blocks</h3>
            <p>
              Energy system training designed to improve endurance,
              output, and recovery capacity.
            </p>
          </div>
        </div>
      </section>


      {/* ================= SPECIALTY SERVICES ================= */}
      <section className="srv7-special">
        <h2>Specialized Support</h2>

        <div className="special-grid">
          <div className="special-item">
            <span>01</span>
            <h4>Mobility & Recovery</h4>
            <p>
              Dedicated sessions to improve joint range, tissue quality,
              and post-training recovery.
            </p>
          </div>

          <div className="special-item">
            <span>02</span>
            <h4>Athletic Development</h4>
            <p>
              Speed, agility, power, and coordination training for
              sport-focused performance.
            </p>
          </div>

          <div className="special-item">
            <span>03</span>
            <h4>Movement Assessment</h4>
            <p>
              In-depth evaluation of posture, mechanics, and imbalances
              to guide safer training.
            </p>
          </div>

          <div className="special-item">
            <span>04</span>
            <h4>Lifestyle Coaching</h4>
            <p>
              Support for sleep, stress management, and habit building
              to reinforce training results.
            </p>
          </div>
        </div>
      </section>


      {/* ================= PROCESS ================= */}
      <section className="srv7-process">
        <h2>How Our Services Work</h2>

        <div className="process-steps">
          <div className="step">
            <strong>Assess</strong>
            <p>We evaluate movement, goals, and current capacity.</p>
          </div>

          <div className="step">
            <strong>Plan</strong>
            <p>Programs are structured around your needs and timeline.</p>
          </div>

          <div className="step">
            <strong>Train</strong>
            <p>Sessions are coached, intentional, and progressive.</p>
          </div>

          <div className="step">
            <strong>Adapt</strong>
            <p>Training evolves based on performance and recovery.</p>
          </div>
        </div>
      </section>


      {/* ================= SERVICE STATEMENT ================= */}
      <section className="srv7-statement">
        <h2>
          SERVICES BUILT FOR <span>RESULTS</span>
        </h2>
        <p>
          No trends. No randomness. Just structured training systems
          that work.
        </p>
      </section>

    </div>
  );
};

export default Services;
